import { render, staticRenderFns } from "./editor_rewrite.vue?vue&type=template&id=e96fce3c"
import script from "./editor_rewrite.vue?vue&type=script&lang=js"
export * from "./editor_rewrite.vue?vue&type=script&lang=js"
import style0 from "./editor_rewrite.vue?vue&type=style&index=0&id=e96fce3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports